import { type FC, memo } from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import type { CustomerSummary } from "../customerSummariesApi";
import type { ClientDialogType } from "../useClientDialog";
import ClientNameCell from "./ClientNameCell";
import ClientContactCell from "./ClientContactCell";
import ClientStatusChip from "./ClientStatusChip";
import ContactPersonsCell from "./ContactPersonsCell";
import LastActivityCell from "./LastActivityCell";
import ClientRowActions from "./ClientRowActions";

interface Props {
  client: CustomerSummary;
  selected: boolean;
  onToggle: (id: string) => void;
  onOpenDialog: (type: ClientDialogType, client: CustomerSummary) => void;
}

const ClientRow: FC<Props> = ({ client, selected, onToggle, onOpenDialog }) => (
  <TableRow hover selected={selected}>
    <TableCell padding="checkbox">
      <Checkbox checked={selected} onChange={() => onToggle(client.id)} />
    </TableCell>
    <ClientNameCell client={client} />
    <ClientContactCell
      phone={client.phone ?? ""}
      email={client.email ?? "—"}
      onOpenHelpdesk={() => onOpenDialog("helpdesk", client)}
    />
    <TableCell>
      <ClientStatusChip status={client.status} />
    </TableCell>
    <ContactPersonsCell client={client} />
    <LastActivityCell client={client} />
    <ClientRowActions
      onOpenNotes={() => onOpenDialog("notes", client)}
      onOpenStats={() => onOpenDialog("stats", client)}
    />
  </TableRow>
);

/** Memoized: toggling one row's checkbox must not re-render every other rendered row. */
export default memo(ClientRow);
